import { z } from 'zod'

export const answerSheetObject = z.object({
  id: z.string().describe('ID'),
  userId: z.string().describe('ID do usuário').nullish(),
  citizenCns: z.string().describe('CNS do cidadão').nullish(),
  citizenCpf: z.string().describe('CPF do cidadão').nullish(),
})
